var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.35326 7.94393C7.46238 7.94393 8.35838 8.19577 9.24222 8.74137C7.2403 10.3881 8.24158 13.7795 9.56606 14.2313L0.66974 14.2236C0.6371 14.046 0.6371 13.8531 0.6371 13.6604C0.6371 10.4969 3.19038 7.94393 6.35326 7.94393ZM6.35326 1.47193C7.81598 1.47193 9.02014 2.65977 9.02014 4.13881C9.02014 5.59897 7.81598 6.80313 6.35326 6.80313C4.87742 6.80313 3.68862 5.59897 3.68862 4.13881C3.68862 2.66009 4.87742 1.47193 6.35326 1.47193Z",
    fill: "#BDC0C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.136 8.08773C13.9181 8.08773 15.3629 9.53381 15.3629 11.3156C15.3629 13.0823 13.9181 14.5281 12.136 14.5281C10.3689 14.5281 8.92445 13.0823 8.92445 11.3156C8.92445 9.53381 10.3686 8.08773 12.136 8.08773ZM11.7494 13.5162H12.5209V11.6855H14.3363V10.9143H12.5209V9.09989H11.7494V10.9143H9.93565V11.6855H11.7494V13.5162Z",
    fill: "#BDC0C1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.36dd08d0f54e9964b97208a0a8605345.svg";
export { ForwardRef as ReactComponent };